import React from "react";
import { Header, List } from "./component";
import "./WeeklyTimeSheet.css";

const WeeklyTimeSheet = () => {
  return (
    <>
        
      <List />
    </>
  );
};

export default WeeklyTimeSheet;
